export default __webpack_public_path__ + "static/media/main-logo.c513c5a6.svg";